import React from 'react';
import { Link, useNavigate, useLocation } from 'react-router-dom';
import { LayoutDashboard, BookOpen, FileText, Users, CreditCard, LogOut, Home as HomeIcon, Award, List } from 'lucide-react';
import { Button } from '../../components/ui/button';
import { usePrepAuth } from '../../contexts/PrepAuthContext';

export const PrepAdminLayout = ({ children, title }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const { user, logout } = usePrepAuth();

  const handleLogout = async () => {
    await logout();
    navigate('/');
  };

  const menuItems = [
    { path: '/prep/admin', label: 'Dashboard', icon: LayoutDashboard },
    { path: '/prep/admin/programs', label: 'Programs', icon: BookOpen },
    { path: '/prep/admin/materials', label: 'Materials', icon: FileText },
    { path: '/prep/admin/students', label: 'Students', icon: Users },
    { path: '/prep/admin/enrollments', label: 'Enrollments', icon: CreditCard },
    { path: '/prep/admin/content/home', label: 'Edit Home', icon: HomeIcon },
    { path: '/prep/admin/content/certification', label: 'Edit Certification', icon: Award },
    { path: '/prep/admin/content/individual', label: 'Edit Individual', icon: List },
  ];

  const isActive = (path) => location.pathname === path;

  return (
    <div className="min-h-screen bg-gray-100 flex">
      <div className="w-64 bg-blue-950 text-white flex flex-col">
        <div className="p-6 border-b border-blue-800">
          <h1 className="text-xl font-bold">PUSH Certification Prep</h1>
          <p className="text-sm text-blue-300">Admin Panel</p>
        </div>
        <nav className="flex-1 p-4 overflow-y-auto">
          <Link
            to="/prep"
            className="flex items-center gap-3 px-4 py-3 rounded-lg mb-4 text-blue-200 hover:bg-blue-800 border border-blue-700 transition-colors"
          >
            <HomeIcon size={20} />
            <span>View Website</span>
          </Link>
          {menuItems.map((item) => {
            const Icon = item.icon;
            return (
              <Link
                key={item.path}
                to={item.path}
                className={`flex items-center gap-3 px-4 py-3 rounded-lg mb-2 transition-colors ${
                  isActive(item.path)
                    ? 'bg-blue-600 text-white'
                    : 'text-blue-200 hover:bg-blue-800'
                }`}
              >
                <Icon size={20} />
                <span>{item.label}</span>
              </Link>
            );
          })}
        </nav>
        <div className="p-4 border-t border-blue-800">
          <div className="text-sm text-blue-300 mb-2 truncate">{user?.email}</div>
          <Button
            onClick={handleLogout}
            variant="outline"
            className="w-full border-blue-700 text-blue-200 hover:bg-blue-800"
          >
            <LogOut size={16} className="mr-2" />
            Logout
          </Button>
        </div>
      </div>

      <div className="flex-1 flex flex-col">
        <header className="bg-white border-b border-gray-200 px-8 py-4">
          <h2 className="text-2xl font-bold text-gray-900">{title}</h2>
        </header>
        <main className="flex-1 p-8 overflow-auto">
          {children}
        </main>
      </div>
    </div>
  );
};
